import { createAction } from "@reduxjs/toolkit";

export const UPDATE_FILES = '[FILES] Files saved';

export const updateFiles = createAction(UPDATE_FILES);